import { Card } from './Card'
import SkeletonStyles from './SkeletonProfileCard.module.scss'
import Styles from './ErrorProfileCard.module.scss'
import cx from 'classnames'
import { SUPPORT_EMAIL } from '../../utils/constants'

export const ErrorProfileCard = () => (
  <Card
    coverImage={<div className={SkeletonStyles.placeholder} />}
    profileImage={<div className={cx(SkeletonStyles.placeholder, SkeletonStyles.dark, Styles.error)}>!</div>}
    className={SkeletonStyles.icon}
  >
    <p>There was an error trying to display this profile.</p>
    <p>{`If the issue persists, please contact ${SUPPORT_EMAIL}.  Thank you!`}</p>
  </Card>
)
